import axios from '@axios'

// Отзыв о кабинете: окно с оценкой показывается сразу после отправки заявки.
// Раздел «Обратная связь» в меню жил сам по себе — туда не заходили.
export default {
  namespaced: true,
  state: {
    // null — ещё не спрашивали сервер; true/false — оставлял ли клиент отзыв.
    submitted: null,
  },
  getters: {
    isSubmitted: state => state.submitted,
  },
  mutations: {
    set_submitted(state, value) {
      state.submitted = value
    },
  },
  actions: {
    // Оставлял ли этот клиент отзыв. Сервер отвечает по логину, поэтому смена
    // браузера окно заново не вызовет.
    fetchState({ commit, state }) {
      if (state.submitted !== null) return Promise.resolve(state.submitted)

      return axios({ method: 'get', url: '/api/v1/feedback' })
        .then(response => {
          const submitted = !!(response.data && response.data.submitted)
          commit('set_submitted', submitted)

          return submitted
        })

        // Сервер не ответил — считаем, что отзыв уже есть: лучше не показать
        // окно, чем показать его невпопад.
        .catch(() => {
          commit('set_submitted', true)

          return true
        })
    },

    // Возвращает true, только если сервер отзыв ПРИНЯЛ. Общий перехватчик
    // ошибок в @axios не бросает исключение, а возвращает объект ошибки —
    // поэтому проверяем именно наличие success в теле ответа, иначе неудачная
    // отправка выглядела бы удачной и окно закрывалось молча.
    submit({ commit }, { ratingHalfStars, comment }) {
      return axios({
        method: 'post',
        url: '/api/v1/feedback/submit',
        data: { rating_half_stars: ratingHalfStars, comment },
      })
        .then(response => {
          const ok = !!(response && response.data && response.data.success)
          if (ok) commit('set_submitted', true)

          return ok
        })
        .catch(() => false)
    },
  },
}
